import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProcessesService {

  private _processes = [{
    id: 'iotsens-ingestion-dispatcher'
  }, {
    id: 'iotsens-knowledge-expressions'
  }, {
    id: 'iotsens-ingestion-decoder'
  }, {
    id: 'ingestion-une82326-hub-0238-v2'
  }, {
    id: 'iotsens-knowledge-persistence'
  }, {
    id: 'iotsens-knowledge-lastvalues'
  }, {
    id: 'iotsens-knowledge-dispatcher'
  }, {
    id: 'iotsens-knowledge-ruleengine'
  }, {
    id: 'iotsens-knowledge-subscriptions'
  }, {
    id: 'facsa-estimations'
  }, {
    id: 'google-geolocation'
  }];

  get processes() {
    return this._processes;
  }

}
